module.exports = __webpack_public_path__ + "img/visa_footer.b168482.svg";